import { createColumns, makePersonLogoCellTemplate, prefixColumnOverrides, urlCellTemplate } from "../framework/tabulars";
import { getUITranslation } from "../utils/get_ui_translation";

/**
 * Create columns for base DataGrid instanciations.
 * The equivalent for the custom DataGrid API is `traineesWithFixedColumnsColumnOverrides`.
 *
 * @see traineesWithFixedColumnsColumnOverrides
 */
export function tabularTraineesWithFixedColumns(fields, visibles) {
  return createColumns(
    fields,
    [
      {
        dataField: "trainee_logo_url",
        cellTemplate: makePersonLogoCellTemplate({
          idField: "trainee_id",
          firstnameField: "trainee_firstname",
          lastnameField: "trainee_lastname",
          alt: getUITranslation("Photo de l'apprenant"),
        }),
        fixed: true,
        visibleIndex: 1,
        allowSorting: false,
        allowFiltering: false,
        width: 50,
        alignment: "right",
      },
      {
        dataField: "trainee_lastname",
        cellTemplate: traineeUrlCellTemplate,
        fixed: true,
        visibleIndex: 2,
        sortIndex: 0,
        sortOrder: "asc",
      },
      {
        dataField: "trainee_firstname",
        cellTemplate: traineeUrlCellTemplate,
        fixed: true,
        visibleIndex: 3,
      },
      {
        dataField: "trainee_second_lastname",
        cellTemplate: traineeUrlCellTemplate,
        fixed: true,
      },
      {
        dataField: "trainee_birthdate",
        cellTemplate: dateCellTemplate,
      },
      {
        dataField: "trainee_note",
        cellTemplate: longTextCellTemplate,
      },
    ],
    visibles
  );
}

/**
 * Create columns for the custom DataGrid API.
 * The equivalent for base DataGrid instanciations is `tabularTraineesWithFixedColumns`.
 *
 * @see tabularTraineesWithFixedColumns
 *
 * @param {Object} options
 * @param {string} options.columnsPrefix - Prefix to add to each column dataField.
 */
export function traineesWithFixedColumnsColumnOverrides(options) {
  const { columnsPrefix } = options;

  const traineeUrlCellTemplate = makeTraineeUrlCellTemplate(columnsPrefix + "id");

  const columnOverrides = {
    logo_url: {
      cellTemplate: makePersonLogoCellTemplate({
        idField: columnsPrefix + "id",
        firstnameField: columnsPrefix + "firstname",
        lastnameField: columnsPrefix + "lastname",
        alt: getUITranslation("Photo de l'apprenant"),
      }),
      fixed: true,
      visible: true,
      visibleIndex: 1,
      allowSorting: false,
      allowFiltering: false,
      width: 50,
      alignment: "right",
    },
    lastname: {
      cellTemplate: traineeUrlCellTemplate,
      fixed: true,
      visible: true,
      visibleIndex: 2,
      sortIndex: 0,
      sortOrder: "asc",
    },
    firstname: {
      cellTemplate: traineeUrlCellTemplate,
      fixed: true,
      visible: true,
      visibleIndex: 3,
    },
    second_lastname: {
      cellTemplate: traineeUrlCellTemplate,
      fixed: true,
    },
    birthdate: {
      cellTemplate: dateCellTemplate,
    },
    note: {
      cellTemplate: longTextCellTemplate,
    },
  };

  return prefixColumnOverrides(columnOverrides, columnsPrefix);
}

/**
 * Create columns for the custom DataGrid API.
 * The equivalent for base DataGrid instanciations is `tabularTraineesWithFixedColumns`.
 */
export function traineeColumnOverrides() {
  return {
    trainee_logo_url: {
      cellTemplate: makePersonLogoCellTemplate({
        idField: "trainee_id",
        firstnameField: "trainee_firstname",
        lastnameField: "trainee_lastname",
        alt: getUITranslation("Photo de l'apprenant"),
      }),
      visible: true,
      visibleIndex: 1,
      allowSorting: false,
      allowFiltering: false,
      width: 50,
      alignment: "right",
    },
    trainee_lastname: {
      cellTemplate: traineeUrlCellTemplate,
      visible: true,
      visibleIndex: 2,
    },
    trainee_firstname: {
      cellTemplate: traineeUrlCellTemplate,
      visible: true,
      visibleIndex: 3,
    },
    trainee_second_lastname: {
      cellTemplate: traineeUrlCellTemplate,
    },
    trainee_birthdate: {
      cellTemplate: dateCellTemplate,
    },
    trainee_note: {
      cellTemplate: longTextCellTemplate,
    },
  };
}

function dateCellTemplate(container, options) {
  if (options.displayValue) {
    let date = options.displayValue.toLocaleString("fr", { year: "numeric", month: "numeric", day: "numeric" });
    $(`<span>${date}</span>`).appendTo(container);
  }
}

function longTextCellTemplate(container, options) {
  let shortVersion = _.truncate(options.displayValue, {
    length: 20,
  });
  $(`<span title="${options.displayValue}">${shortVersion}</span>`).appendTo(container);
}

const traineeUrlCellTemplate = makeTraineeUrlCellTemplate("trainee_id");

function makeTraineeUrlCellTemplate(fieldId) {
  return (container, options) => {
    const traineeId = options.row.data[fieldId];
    const url = p`/trainees/${traineeId}/edit`;
    const title = options.displayValue;
    urlCellTemplate(url, title, container);
  };
}
